/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useAuth0} from '@auth0/auth0-react';
import {useCallback, useContext} from 'react';
import {APIParams, useTrusstedAgent} from '../../../hooks/abstractions/useTrusstedAgent';
import {RuntimeConfigContext} from '../../../providers/RuntimeContextProvider';

export const useAgentsAPI = () => {
  const runtimeContext = useContext(RuntimeConfigContext);
  const apiEndpoint = runtimeContext?.trusstedAgentApiUrl;
  const {getAccessTokenSilently} = useAuth0();

  return useCallback(
    (params: APIParams) =>
      useTrusstedAgent({
        apiEndpoint: apiEndpoint as string,
        getAccessToken: getAccessTokenSilently,
        ...params,
      }),
    [apiEndpoint],
  );
};
